import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "./login.service";
import { LocalStorageService } from "../../core/local-storage.service";
import {
  LoginModel,
  LanguageModel,
  PushNotificationTokenModel,
  Token,
} from "./login.model";
import { LoaderService } from "../../shared/services/loader.service";
import {
  LanguageCodeEnum,
  RoleEnum,
  UserStatusCD,
} from "../../shared/enum/base.enum";
import { UserPermissionModel } from "../../components/user/shared/user.model";
import { UserService } from "../../components/user/shared/user.service";
import { LanguageTranslatorComponent } from "../../shared/language-convertor/language-translator.component";
import { UserProfileModel } from "../../components/profile/shared/profile.model";
import { ProfileService } from "../../components/profile/shared/profile.service";
import { ToastrManager } from "ng6-toastr-notifications";
import { MessagingService } from "../../shared/services/messaging-service";
import { PushNotificationService } from "../../shared/services/push-notification.service";
import { MasterService } from "../../shared/services/master.service";

@Component({
  selector: "app-login",
  templateUrl: "login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent
  extends LanguageTranslatorComponent
  implements OnInit
{
  loginModel: LoginModel = new LoginModel();
  isFilledAllRequiredField: boolean = true;
  submitted = false;
  showButton = false;
  showIcon: string;
  user: UserProfileModel = new UserProfileModel();
  selectedLanguage: string = "ENGLISH";
  @ViewChild("password", { static: false }) password: ElementRef;
  notifcationTokenModel: PushNotificationTokenModel =
    new PushNotificationTokenModel();
  languageList: Array<LanguageModel> = new Array<LanguageModel>();
  message: any;
  token: Token = new Token();

  constructor(
    private loginService: LoginService,
    private router: Router,
    public localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private userService: UserService,
    private profileService: ProfileService,
    private msgService: MessagingService,
    private toastr: ToastrManager,
    private masterService : MasterService,
    private notificationService: PushNotificationService
  ) {
    super(localStorageService);

    // this.msgService.getPermission();
    // this.msgService.receiveMessage();
    this.message = this.msgService.currentMessage;
  }

  ngOnInit() {
    this.showIcon = "fa fa-eye";
    this.getLanguages();
    //this.getLanguageData();
  }

  getLanguageData() {
    const obj = {
      language: this.selectedLanguage,
      interface: "Web_Admin_Panel",
    };
    this.masterService.getLanguageData(obj).subscribe((res: any) => {
      if (res) {
        this.localStorageService.setSelectedLanguageData(res);
      }
    });
  }

  setLanguage() {
    const index = this.languageList.findIndex(
      (res) => res.code === this.languageCode
    );
    if (index >= 0) {
      this.selectedLanguage = this.languageList[index].name;
      this.getLanguageData();
    }
    this.localStorageService.setLanguage(this.languageCode);
    this.localStorageService.setCurrentUsedLanguage(this.languageCode);
  }

  showHidePassword() {
    let x: any;
    x = this.password.nativeElement;
    if (x.type === "password") {
      x.type = "text";
      this.showIcon = "fa fa-eye-slash";
    } else {
      x.type = "password";
      this.showIcon = "fa fa-eye";
    }
  }

  getLanguages() {
    this.masterService.getLanguages().subscribe(
      (res) => {
        this.languageList = res;
        this.languageList.map((res) => {
          (res.label = res.name), (res.value = res.code);
        });
        this.showButton = true;
        this.setLanguage();
      },
      (err) => {}
    );
  }

  async onLogin(value) {
    if (!value) {
      this.isFilledAllRequiredField = false;
    } else {
      const formData = new FormData();
      formData.append("client_id", "admin_ui");
      formData.append("grant_type", "password");
      formData.append(
        "username",
        this.loginModel.userName.toLowerCase().trim()
      );
      formData.append("password", this.loginModel.password);
      formData.append("languagecode", this.languageCode);
      this.loaderService.showLoader();
      this.loginService.login(formData).subscribe(
        (res) => {
          if (res) {
            this.localStorageService.setCurrentUser(res);
            this.getUserProfile(res);
            this.saveNotificationPermission();
            // this.getUserPermission();
          }
        },
        (err) => {
          this.loaderService.hideLoader();
        }
      );
    }
  }

  async getUserProfile(res) {
    this.profileService.getUserProfile().subscribe(
      (result: UserProfileModel) => {
        if (result) {
          this.user = result;
          if (result.userStatusCD !== UserStatusCD.Approved) {
            this.loaderService.hideLoader();
            this.localStorageService.removeLogin();
            const msg = this.localStorageService.getValue(
              "AccountNotApproved",
              this.languageCode
            );
            this.toastr.errorToastr(msg);
          } else {
            if (result.roleId === RoleEnum.Sub_Admin) {
              this.getUserPermission();
              // this.router.navigate(["/dashboard/welcome"]);
              this.loaderService.hideLoader();
            } else {
              this.loaderService.hideLoader();
              this.router.navigate(["/"]);
            }
          }
        }
      },
      (err) => {
        this.loaderService.hideLoader();
      }
    );
  }

  getUserPermission() {
    this.userService.getUserPermission().subscribe(
      (result: UserPermissionModel[]) => {
        this.loaderService.hideLoader();
          this.localStorageService.permission.next(result);
        this.router.navigate(["/dashboard/welcome"]);
      },
      (err) => {
        this.loaderService.hideLoader();
      }
    );
  }

  retreivePasswordDetails() {
    this.router.navigate(["forgot-password"], {
      queryParams: { languageCode: this.languageCode },
    });
  }

  saveNotificationPermission() {
    this.msgService.getPermission();
    this.msgService.receiveMessage();

    var notification_token = localStorage.getItem("notification_token");
    if (notification_token) {
      this.notifcationTokenModel.tokenValue = notification_token;
      this.notifcationTokenModel.sourceType = "AdminWeb";
      var user = this.localStorageService.getCurrentUserDetail();
      var userAccessToken = this.localStorageService.getAccessToken();

      this.notifcationTokenModel.userAuthToken = userAccessToken;
      this.notifcationTokenModel.servicUserUId = user.tableuidvalue;
      this.notificationService
        .registerFireBaseToken(this.notifcationTokenModel)
        .subscribe((res) => {
        });
    }
  }
}
